import React from 'react'
import s from './GeoentityBlockText.less'
import classNames from 'classnames'

import { getComponentOrClassNameByGeoentityBlockAspect } from './GeoentityBlockUtils'

export default function GeoentityBlockText(props) {
  const className = getComponentOrClassNameByGeoentityBlockAspect(
    {
      normal: s.normal,
      bulleted: s.bulleted,
      quote: s.quote
    },
    props.data
  )

  if (!className) return null

  return <div className={classNames(s.text, className)}>{props.data.text}</div>
}
